module.exports = __webpack_public_path__ + "testimonial-tenant-758a6658e82ef09037fd3c43866ce124.bundle.jpg";